export default function barChartPlotter(e, large = false) {
  let ctx = e.drawingContext;
  let points = e.points;
  let YBottom = e.dygraph.toDomYCoord(0); // see <a href="http://dygraphs.com/jsdoc/symbols/Dygraph.html#toDomYCoord">jsdoc</a>

  // This should really be based on the minimum gap
  let barWidth = large ? 10 : 1;

  ctx.fillStyle = e.color; // a lighter shade might be more aesthetically pleasing

  // Do the actual plotting.
  for (let i = 0; i < points.length; i++) {
    let p = points[i];
    let centerX = p.canvasx; // center of the bar

    ctx.fillRect(
      centerX - barWidth / 2,
      p.canvasy,
      barWidth,
      YBottom - p.canvasy,
    );
    ctx.strokeRect(
      centerX - barWidth / 2,
      p.canvasy,
      barWidth,
      YBottom - p.canvasy,
    );
  }
}
